import React, { useEffect, useState } from "react";
import { Button, Input, AlertDialog } from "react-onsenui";
import Cookies from "js-cookie";
import HomeScreen from "./HomeScreen";
import RegistrationScreen from "./RegistrationScreen";
import { BASE_URL, generateOTP, verifyOTP } from "../apiService"; // Import generateOTP function
import { FormNextLink } from "grommet-icons";
import { Navbar } from "..";
import { useTranslation } from "react-i18next";
import "../i18n";
import i18n from "../i18n";
import axios from "axios";

const OTPScreen = ({ navigator, route }) => {
  const { t } = useTranslation();
  const { data } = route;
  const contact = data?.contact;
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [dialogShown, setDialogShown] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [language, setLanguage] = useState("en");
  const [key, setKey] = useState(0);
  const [timer, setTimer] = useState(180); // 3 minutes in seconds
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    const savedLanguage = Cookies.get("language") || "en";
    setLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage).then(() => {
      setKey((prevKey) => prevKey + 1);
    });
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language).then(() => {
      setKey((prevKey) => prevKey + 1);
      Cookies.set("language", language, { expires: 7 });
    });
  }, [language]);

  useEffect(() => {
    // Start countdown timer when component mounts or resend button is clicked
    if (timer > 0) {
      const countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendDisabled(false); // Enable resend button when timer reaches 0
    }
  }, [timer]);
  const handleResendOTP = async () => {
    setLoading(true);
    try {
      await generateOTP({ mobile: contact, name: "Dummy-name" }); 
      setTimer(180);
      setIsResendDisabled(true); 
      setDialogMessage(t("OTP has been resent successfully."));
      setDialogShown(true);
    } catch (error) {
      setDialogMessage(t(`Failed to resend OTP: ${error.message}`));
      setDialogShown(true);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp || otp.length !== 4) {
      setDialogMessage(t("Please enter a valid 4-digit OTP."));
      setDialogShown(true);
      return;
    }

    setLoading(true);
    try {
      const response = await verifyOTP(contact, otp);
      const token = response.data.token;
      Cookies.set("RATIFI_REDUX_TOKEN", token);
      console.warn("RESPONSE",response)
      // if (response.message === "AVAILABLE") {


      //   const ownerId = response.data.user?._id; // Assuming _id is returned in the response
      //   console.warn(ownerId);
        
      //   const claimsResponse = await axios.post(
      //     `${BASE_URL}/claims`,
      //     {
      //       ownerId,
      //     },
      //     {
      //       headers: { Authorization: `Bearer ${token}` },
      //     }
      //   );
  
      //   console.warn("claim", claimsResponse.data);
      //   // Extract claim number and save it in cookies
      //   const claimNumber = claimsResponse.data?.data?._id; // Assuming claimNumber is in the response
      //   console.warn('claimNumber',claimNumber)
      //   const claimData = claimsResponse.data?.data; // Assuming the API returns claim data
      //   console.warn('claimData',claimData)
        
      //   if (claimNumber) {
      //     const len = claimsResponse.data?.data?.claims?.length;
      //     Cookies.set("CLAIM_NUMBER", claimsResponse.data?.data?.claims[len - 1]); // Save claim number in cookies for 7 days
      //   } else {
      //     console.warn("Claim number not found in the response.");
      //   }
  
      //   // Save claim data in IndexedDB
      //   if (claimData) {
      //     await saveClaimToIndexedDB({ ...claimData, id: claimData?._id });
      //     console.log("Claim data saved to IndexedDB:", claimData);
      //   }
  
      //   // Navigate to the Home Screen
      //   navigator.pushPage({ title: "Home Screen", component: HomeScreen });

      
        








      //   navigator.pushPage(
      //     { title: "HomeScreen", component: HomeScreen },
      //     { animation: "slide" }
      //   );
      // } else {
      //   navigator.pushPage(
      //     {
      //       title: "Registration Screen",
      //       component: RegistrationScreen,
      //       data: { contact },
      //       isRenderToolbar: true,
      //     },
      //     { animation: "slide" }
      //   );
      // }

      navigator.pushPage(
        {
          title: "Registration Screen",
          component: RegistrationScreen,
          data: { contact },
          isRenderToolbar: true,
        },
        { animation: "slide" }
      );
      
    } catch (error) {
      setDialogMessage(t(`Failed to verify OTP: ${error.message}`));
      setDialogShown(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: "center" }} key={key}>
      <Navbar language={language} setLanguage={setLanguage} />
      <h2>{t("Enter OTP")}</h2>
      <p>
        {t("An OTP has been sent to")}
        <b> +91{contact || t("your registered mobile number")} </b>
      </p>
      <input
        modifier="transparent"
        type="tel"
        value={otp}
        onChange={(e) => {
          console.log('e',e)
          setOtp(e.target.value)
        }}
        placeholder={t("Enter 4 digit OTP")}
        style={{
          marginBottom: 20,
          width: "100%",
          border: "solid 1px gray",
          borderRadius: 5,
          padding: "5px 10px",
        }}
      />
      <p>
        OTP {t("Didn't receive?")}{' '}
        <button
          
          onClick={handleResendOTP}
          style={{ 
            cursor: isResendDisabled ? "not-allowed" : "pointer",
            background:'transparent',
            border:'none',
            outline:'none'

           }}
          disabled={isResendDisabled}
        >
          <b>&nbsp;{t("Resend OTP")}</b>
        </button>
        {true && (
          <span style={{ marginLeft: "10px", color: "gray" }}>
            [ {Math.floor(timer / 60)}:{String(timer % 60).padStart(2, "0")} ]
          </span>
        )}
      </p>
      <Button
        onClick={handleVerifyOTP}
        disabled={loading}
        style={{ marginTop: "20px", background: "#5C7232" }}
      >
        {loading ? (
          t("Verifying...")
        ) : (
          <div>
            {t("Continue")} <FormNextLink color="white" />
          </div>
        )}
      </Button>

      <AlertDialog
        isOpen={dialogShown}
        onCancel={() => setDialogShown(false)}
        cancelable
      >
        <div className="alert-dialog-title">{t("Error")}</div>
        <div className="alert-dialog-content">{dialogMessage}</div>
        <div className="alert-dialog-footer">
          <Button
            onClick={() => setDialogShown(false)}
            className="alert-dialog-button"
          >
            {t("OK")}
          </Button>
        </div>
      </AlertDialog>
    </div>
  );
};

export default OTPScreen;



const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("ClaimSyncDB", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("claim-images")) {
        db.createObjectStore("claim-images", {
          keyPath: "id",
          autoIncrement: true,
        });
      }
      if (!db.objectStoreNames.contains("claims")) {
        db.createObjectStore("claims", { keyPath: "_id" });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

const saveClaimToIndexedDB = async (claimData) => {
  try {
    const db = await openDB();
    const tx = db.transaction("claims", "readwrite");
    const store = tx.objectStore("claims");
    store.put(claimData);
    await tx.complete;
    console.log("Claim data saved to IndexedDB successfully.");
  } catch (error) {
    console.error("Failed to save claim data to IndexedDB:", error);
  }
};
